import {Component, OnInit, inject} from '@angular/core';
import {VtnGenericaComponent} from '../../vtn-generica/vtn-generica.component';
import {ClsObjGenerico} from '../../../../../clases-pu/util/cls-obj-generico';
import {GenericoService} from '../../../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../../../core/services/app-info.service';
import {ClsConfig} from '../../../../../util/cls-config';
import {ClsEmpresas} from '../../../../../core/models/cls-catalogos';
import {TranslateModule} from '@ngx-translate/core';
import {BtnUrlContenidoComponent} from '../../../controles/btn-url-contenido/btn-url-contenido.component';
import { IGX_TABS_DIRECTIVES, IgxTabsModule } from '@infragistics/igniteui-angular/tabs';
import { IgxLayoutModule } from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import {FormsModule} from "@angular/forms";
import {UppercaseDirective} from "../../../../../core/directivas/uppercase.directive";

@Component({
  selector: 'app-detalle-empresa',
  templateUrl: './detalle-empresa.component.html',
  styleUrls: ['./detalle-empresa.component.scss'],
  imports: [
    IgxTabsModule,
    IGX_TABS_DIRECTIVES,
    TranslateModule,
    IgxLayoutModule,
    IGX_INPUT_GROUP_DIRECTIVES,
    BtnUrlContenidoComponent,
    FormsModule,
    UppercaseDirective,
    IgxInputGroupComponent,
  ]
})
export class DetalleEmpresaComponent extends ClsConfig implements OnInit {
  private servicioGen = inject(GenericoService);
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);

  public titulo: string;
  public registroSeleccionado: ClsEmpresas = new ClsEmpresas();
  public vtnGenerico: VtnGenericaComponent;
  // obj
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  open() {
    this.titulo = `${this.mObjGenerico.getTranslationsMensajes('TITULOS.DETALLE_BUS_GRAL')}: ${this.registroSeleccionado.Empresa}`;
    this.vtnGenerico.open(423, 700, this.titulo, '');
  }

  close() {
    this.vtnGenerico.close();
  }
}
